export default __webpack_public_path__ + "static/media/bank_bri.612c73a0.svg";